var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#151F28",
    fillRule: "evenodd",
    d: "M8 0C5.66 0 3.765 1.849 3.765 4.129c0 1.924 1.35 3.54 3.176 3.999L7.655 16l1.03-2.076.374-5.796c1.827-.458 3.176-2.075 3.176-3.999C12.235 1.849 10.34 0 8 0m-.47 3.765a.941.941 0 1 1 0-1.883.941.941 0 0 1 0 1.883",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.a373697819d6d3412971cbf9ce3b2185.svg";
export { ForwardRef as ReactComponent };